import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { Loading, HeaderModal, Toast } from "../../../../components";
import Filter from "./Filter";
import empty from "../../../../assets/images/Emty.png";
import styles from "./ModalCamera.module.css";
import { LoseConnectStatus, OffStatus, OnStatus, WeakConnectStatus } from "../../../../components/Icons/Icons";
import { changeDataCam, sorterArrayChildIsManyObj } from "../../../../utils";
import NameCol from "../../../../components/NameCol";
import { cameraManagement } from "../../../../services/api/cameraManagementApi";
import RenderStatus from "../../../../components/StatusRender";

const cx = classNames.bind(styles);
// eslint-disable-next-line
const ModalCamera = ({ onClose, onOK, listCam }) => {
  const [dataSelect, setDataSelect] = useState([]);
  const [check, setCheck] = useState({});
  const [toggleSort, setToggleSort] = useState(false);
  const [dataTable, setDataTable] = useState();
  const [method, setMethod] = useState('');
  const [province, setProvince] = useState();
  const [commune, setCommune] = useState();
  const [district, setDistrict] = useState();
  const [status, setStatus] = useState();
  const [textSearch, setTextSearch] = useState();
  const [data, setData] = useState();
  const companyCode = sessionStorage.getItem('company_code');
  const refModal = useRef(null);
  useEffect(() => {
    const getListCamera = async () => {
      let params = {
        province_code: province ? province : null,
        district_code: district ? district : null,
        commune_code: commune ? commune : null,
        status_active: status ? status : null,
        camera_name: textSearch ? textSearch : null,
      }
      try {
        const res = await cameraManagement.getList(params)
        const cameraNotCheck = res?.data?.filter(item => listCam.findIndex(item_1 => item_1?.CAMERA?.CODE === item?.CAMERA?.CODE) < 0)
        const data = changeDataCam({ count: res.count, data: cameraNotCheck });
        setData(data)
      } catch (error) {
        Toast.open('Lấy danh sách camera không thành công', 'danger')
      }
    }
    getListCamera()
  }, [province, district, commune, status, textSearch])

  const handleSelect = (e, item) => {
    setCheck({ ...check, [`${e.target.name}`]: e.target.checked });
    if (e.target.checked) {
      setDataSelect([...dataSelect, item]);
    } else {
      const data = dataSelect.filter(
        (data) => data?.CAMERA?.CODE !== item?.CAMERA?.CODE
      );
      setDataSelect(data);
    }
  };
  const handleAdd = () => {
    onOK(dataSelect);
    onClose();
  };

  const handleChangeProvince = (data) => {
    setProvince(data);
  }
  const handleChangeDistrict = (data) => {
    setDistrict(data);
  }
  const handleChangeCommune = (data) => {
    setCommune(data);
  }
  const handleChangeStatus = (data) => {
    if (data !== ' all') {
      setStatus(data);
    } else {
      setData()
    }
  }
  const handleChangeTextSearch = (data) => {
    setTextSearch(data);
  }

  useEffect(() => {
    const newData = data ? data : null
    if (newData) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArrayChildIsManyObj(newData.data, 'CAMERA', method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArrayChildIsManyObj(newData.data, 'CAMERA', method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData.data)
          break;
      }
    } else {
      setDataTable(newData?.data)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }

  useEffect(() => {
    const handleClickOutSide = (e) => {
      if(e.target === refModal.current) {
        onClose()
      }
    } 
    document.addEventListener('click', handleClickOutSide);
    return () => document.removeEventListener('click', handleClickOutSide);
  }, [])

  return (
    <div className={cx("content")} ref={refModal}>
      <div className={cx("container")}>
        {false ? (
          <div className={cx("loading")}>
            <Loading />
          </div>
        ) : (
          <>
            <HeaderModal title="Danh sách camera" onClose={onClose} />
            <Filter
              onChangeProvince={handleChangeProvince}
              onChangeTexSearch={handleChangeTextSearch}
              onChangeDistrict={handleChangeDistrict}
              onChangeCommune={handleChangeCommune}
              onChangeStatus={handleChangeStatus}
            />
            <div className={cx("content-table")} style={{ padding: "0 16px" }}>
              <table className={cx("table")}>
                <thead>
                  <tr>
                    <th>STT</th>
                    <th>
                      <NameCol active={method} title={'Tên camera'} handleSort={handleSort} method={'NAME_CAM'} />
                    </th>
                    <th>
                      <NameCol active={method} title={'Nhóm'} handleSort={handleSort} method={'NAME_CAM'} />
                    </th>
                    <th>
                      <NameCol active={method} title={'Địa điểm'} handleSort={handleSort} method={'PROVINCE_NAME'} />
                    </th>
                    <th>

                      <NameCol active={method} title={'Độ phân giải'} handleSort={handleSort} method={'MAIN_SOURCE'} />
                    </th>
                    <th style={{ textAlign: "center" }}>
                      Chọn {`(${dataSelect.length})`}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataTable && dataTable?.length > 0 &&
                    dataTable?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <div style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                              padding: "14px 0",
                              position: 'relative'
                            }}>
                              <span className={cx('On')}>
                                <RenderStatus status={item?.CAMERA?.STATUS_ACTIVE} companyCode={companyCode} />
                                <p className={cx('tooltip')}>
                                  {item?.CAMERA?.MESSAGE}
                                </p>
                              </span>
                              <span style={{ fontSize: 14 }}>
                                {item?.CAMERA?.NAME_CAM}
                              </span>
                            </div>
                          </td>
                          <td>
                            {item?.GROUP_NAME.map((it, index) => {
                              return (
                                <span key={index} style={{ fontSize: 14 }}>
                                  {it?.GROUP_NAME},{" "}
                                </span>
                              );
                            })}
                          </td>
                          <td>{item?.CAMERA?.PROVINCE_NAME}</td>
                          <td>{item?.CAMERA.MAIN_SOURCE}</td>
                          <td style={{ textAlign: "center" }}>
                            <input
                              type="checkbox"
                              checked={check ? check[`${item?.CAMERA?.CODE}`] : false}
                              name={item?.CAMERA?.CODE}
                              onChange={(e) => handleSelect(e, item)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            {data && data?.data?.length > 0 && (
              <div className={cx("actions")}>
                <button onClick={handleAdd} className={cx("btn-add")}>
                  Thêm mới
                </button>
                <button onClick={() => onClose()} className={cx("btn-cancel")}>
                  Hủy bỏ
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
ModalCamera.propTypes = {
  onClose: PropTypes.func,
  onOK: PropTypes.func,
  listCam: PropTypes.array,
};
export default ModalCamera;
